import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Hourglass } from "lucide-react";

export function AlertaPeriodoPrueba() {
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const load = useCallback(() => api.get("/alertas/periodo-prueba").then((r) => setRes(r.data)).catch(() => setRes(null)), []);
  useEffect(() => { load(); const t = setInterval(load, 300000); return () => clearInterval(t); }, [load]);
  if (!res) return null;
  const urg = res.items.some((i) => i.hito <= 3);
  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} data-testid="alerta-pp-btn" title="Períodos de prueba por terminar"
        className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold shadow-sm transition-transform hover:scale-[1.03] ${res.total ? (urg ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-700") : "bg-emerald-50 text-emerald-700"}`}>
        <Hourglass className="h-4 w-4" /> <span className="hidden 2xl:inline">Período de prueba</span>
        <span className="rounded-full bg-white/90 px-2 text-slate-900" data-testid="alerta-pp-total">{res.total}</span>
      </button>
      {open && (
        <div className="fixed left-2 right-2 top-16 z-40 rounded-xl border border-slate-200 bg-white p-3 shadow-xl sm:absolute sm:left-auto sm:right-0 sm:top-auto sm:mt-2 sm:w-80" data-testid="alerta-pp-panel">
          <p className="mb-2 text-sm font-semibold text-slate-800">Períodos de prueba que terminan en 7 días o menos</p>
          {res.items.length === 0 ? <p className="text-xs text-slate-500">No hay períodos de prueba por terminar.</p> : (
            <div className="max-h-80 divide-y divide-slate-100 overflow-y-auto">
              {res.items.map((i) => (
                <button key={i.vinculacion_id} onClick={() => { setOpen(false); navigate(`/empleados/${i.vinculacion_id}`); }} data-testid={`alerta-pp-item-${i.vinculacion_id}`}
                  className="flex w-full items-center justify-between gap-2 py-2 text-left hover:bg-slate-50">
                  <span className="min-w-0"><span className="block truncate text-sm font-medium text-slate-800">{i.nombre}</span><span className="text-xs text-slate-400">{i.empresa_cliente} · termina {i.fin.split("-").reverse().join("/")}</span></span>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ${i.hito === 1 ? "bg-red-100 text-red-700" : i.hito === 3 ? "bg-orange-100 text-orange-700" : "bg-amber-100 text-amber-700"}`}>
                    {i.dias_restantes === 0 ? "Hoy" : `${i.dias_restantes} d`}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
